import { TableHeader } from "app/components/Table/types";

export const TICKET_HEADERS: TableHeader[] = [
  {
    id: "",
    name: "",
    min: 40,
    max: 80,
    width: 62,
    resizable: false,
    sortable: false,
    className: "",
  },
  {
    id: "name",
    name: "Name",
    min: 200,
    max: 600,
    width: 428,
    resizable: true,
    sortable: true,
    className: "!p-[4px] text-xs leading-[18px] font-medium",
  },
];
